import { combineReducers } from 'redux';
import CurrentOrderReducer from './reducer_current_order';
import OrdersReducer from './reducer_orders';
import RestaurantReducer from './reducer_restaurant';
import { reducer as FormReducer } from 'redux-form';
import AuthReducer from './reducer_auth';
import ReportsReducer from './reducer_reports';
import PunchReducer from './reducer_punch';
import PunchesReducer from './reducer_punches';
import ModalReducer from './reducer_modals';
import PollingReducer from './reducer_polling';

// Combine all the reducers into one
const rootReducer = combineReducers({
  restaurant: RestaurantReducer,
  current_order: CurrentOrderReducer,
  orders: OrdersReducer,
  form: FormReducer,
  auth: AuthReducer,
  reports: ReportsReducer,
  punch: PunchReducer,
  punches: PunchesReducer,
  modals: ModalReducer,
  polling: PollingReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js